<template>
    <div class="wlx-candidate-table-wrapper">
        <div class="basic-head-main" :style="{ backgroundImage: 'url(' + headBg + ')' }">
            <div class="basic-head-con">
                <div class="head-title-con clearfix">
                    <div class="fl basic-book-img-con">
                        <img src="~assets/images/basic-book-img.png" alt />
                    </div>
                    <div class="fr head-title-word">
                        <p class="p-title-1">全国物流职业教育教学指导委员会下设专业委员会候选人推荐表</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="apply-table-content">
            <div class="apply-table-hearrd">全国物流职业教育教学指导委员会下设专业委员会候选人推荐表</div>
            <el-form :model="form" :rules="rules" ref="form">
                <table border="0" cellspacing="0" cellpadding="0">
                    <tr>
                        <td class="u-label-title">姓名</td>
                        <td colspan="2">
                            <el-input v-model="form.name"></el-input>
                        </td>
                        <td class="u-label-title">性别</td>
                        <td colspan="2">
                            <el-select v-model="form.sex" placeholder="请选择" class="train-select-con">
                                <el-option label="男" value="男"></el-option>
                                <el-option label="女" value="女"></el-option>
                            </el-select>
                        </td>
                        <td colspan="2" class="u-label-title">出生日期</td>
                        <td colspan="2">
                            <!-- <el-input v-model="form.bornDate"></el-input> -->
                            <el-date-picker
                                v-model="form.bornDate"
                                type="date"
                                placeholder="选择日期">
                            </el-date-picker>
                        </td>
                        <td class="u-label-title">民族</td>
                        <td colspan="2">
                            <el-input v-model="form.national"></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td class="u-label-title">单位</td>
                        <td colspan="2">
                            <el-input v-model="form.company"></el-input>
                        </td>
                        <td class="u-label-title">单位性质</td>
                        <td colspan="2">
                            <el-select placeholder="请选择" v-model="form.companyType">
                                <!-- <el-option label="本科" :value="1"></el-option>
                                <el-option label="企业" :value="2"></el-option> -->
                                <!-- <el-option label="中职" :value="3"></el-option> -->
                                <el-option label="高职" :value="1"></el-option>
                                <el-option label="中职" :value="3"></el-option>
                                <el-option label="企业" :value="2"></el-option>
                            </el-select>
                        </td>
                        <td colspan="2" class="u-label-title">职务</td>
                        <td colspan="2">
                            <el-input v-model="form.position"></el-input>
                        </td>
                        <td class="u-label-title">职称</td>
                        <td colspan="2">
                            <el-input v-model="form.workTitle"></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td class="u-label-title">学历</td>
                        <td colspan="2">
                            <el-input v-model="form.education"></el-input>
                        </td>
                        <td class="u-label-title">学位</td>
                        <td colspan="2">
                            <el-input v-model="form.degree"></el-input>
                        </td>
                        <td colspan="2" class="u-label-title">毕业院校</td>
                        <td colspan="2">
                            <el-input v-model="form.schoolName"></el-input>
                        </td>
                        <td colspan="1" class="u-label-title">专业</td>
                        <td colspan="2">
                            <el-input v-model="form.majorName"></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="2" class="u-label-title">研究方向</td>
                        <td colspan="6">
                            <el-input v-model="form.research"></el-input>
                        </td>
                        <td colspan="2" class="u-label-title">目前从事专业</td>
                        <td colspan="3">
                            <el-input v-model="form.workMajor"></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="2" class="u-label-title">通讯地址</td>
                        <td colspan="6">
                            <el-input v-model="form.address"></el-input>
                        </td>
                        <td colspan="2" class="u-label-title">邮政编码</td>
                        <td colspan="3">
                            <el-input v-model="form.postalCode"></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="2" class="u-label-title">联系电话</td>
                        <td colspan="6">
                            <el-input v-model="form.phone"></el-input>
                        </td>
                        <td colspan="2" class="u-label-title">手机</td>
                        <td colspan="3">
                            <el-input v-model="form.mobilephone"></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="2" class="u-label-title">身份证号</td>
                        <td colspan="6">
                            <el-input v-model="form.idCard"></el-input>
                        </td>
                        <td colspan="2" class="u-label-title">电子邮箱</td>
                        <td colspan="3">
                            <el-input v-model="form.email"></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="2" class="u-label-title">
                            拟推荐为
                        </td>
                        <td colspan="11" style="text-align: left">
                            <!-- <el-checkbox-group v-model="form.recommendType" :max="1" style="padding: 10px 10px">
                                <el-checkbox :label="1">物流管理专业工作组</el-checkbox>
                                <el-checkbox :label="2">物流工程专业工作组</el-checkbox>
                                <el-checkbox :label="3">采购管理专业工作组</el-checkbox>
                                <el-checkbox :label="4">青年教师工作组</el-checkbox>
                                <el-checkbox :label="5">冷链物流专业工作组</el-checkbox>
                                <el-checkbox :label="6">供应链管理专业工作组</el-checkbox>
                            </el-checkbox-group> -->
                            <el-select v-model="form.recommendType" placeholder="请选择" >
                                <el-option label="高职现代物流管理专业委员会" :value="1"></el-option>
                                <el-option label="高职物流技术类专业委员会" :value="2"></el-option>
                                <el-option label="高职冷链物流技术与管理专业委员会" :value="3"></el-option>
                                <el-option label="高职航空物流管理专业专业委员会" :value="4"></el-option>
                                <el-option label="高职铁路与港口物流管理专业委员会" :value="5"></el-option>
                                <el-option label="高职工程物流管理专业委员会" :value="6"></el-option>
                                <el-option label="高职采购与供应链运营专业委员会" :value="7"></el-option>
                                <el-option label="高职本科物流类专业委员会" :value="8"></el-option>
                                <el-option label="中职物流管理与技术专业委员会" :value="9"></el-option>
                                <el-option label="中职国际货运代理专业委员会" :value="10"></el-option>
                                <el-option label="中职冷链物流服务与管理专业委员会" :value="11"></el-option>
                                <el-option label="师资建设专业委员会" :value="12"></el-option>
                                <el-option label="课程思政建设专业委员会" :value="13"></el-option>
                                <el-option label="两业融合专业委员会" :value="14"></el-option>
                                <el-option label="国际交流与合作专业委员会" :value="15"></el-option>
                            </el-select>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="2" class="u-label-title">工作简历</td>
                        <td colspan="11">
                            <el-input type="textarea" v-model="form.resume" :autosize="{ minRows: 8, maxRows: 24 }"></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="2" class="u-label-title">学术成果</td>
                        <td colspan="11">
                            <el-input type="textarea" v-model="form.achievements" :autosize="{ minRows: 8, maxRows: 24 }"></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="2" class="u-label-title">推荐单位意见</td>
                        <td colspan="11">
                            <el-input type="textarea" v-model="form.opinion" :autosize="{ minRows: 8, maxRows: 24 }" disabled></el-input>
                        </td>
                    </tr>
                </table>
                <el-button  type="primary" size="medium" style="margin-top:10px;margin-left:720px;" @click="saveInfo('form')">
                    确定推荐表信息
                </el-button>
                <el-button  type="primary" size="medium" style="margin-top:10px;" @click="getExportSQBUrl">
                    导出推荐表
                </el-button>
            </el-form>
            <!-- <p class="p-sign-up-tip p-sign-up-tip-1">支撑材料上传：（要求将最高学历证书、职称证书、推荐表盖章扫描件等材料，打包上传）</p>
            <applyFileUpload :url="urlAliyunOSS" :fileLists="form.fileUrl" @done="onAllFilesUploadlLOU" class="apply-file-upload"></applyFileUpload> -->
            <div class="submit-btn">
                <el-button type="primary" @click="fanhui">返回</el-button>
                <!-- <el-button type="primary" @click="exportSQBUrl">导出word</el-button> -->
                <el-button type="primary" @click="submitTable('form')" :disabled="isSubmit">提交</el-button>
                
            </div>
            <div style="color:red;">注：请将盖章版推荐表以及证明材料扫描发送至邮箱wljzw@vip.163.com</div>
        </div>
        <el-dialog
            :close-on-click-modal="false"
            title="填写记录查询"
            :visible.sync="dialogVisible"
            :append-to-body="true"
            width="30%"
            >
            <p style="color:red;margin-bottom: 10px">*如果已经填写过推荐表，请输入身份证号查询。没有填写记录请忽略。</p>
            <span>身份证号：</span> 
            <el-input label="" v-model="SIdcard" placeholder="请输入身份证号" style="width: 300px"></el-input>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="getTableInfo">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 关闭填报弹窗 -->
        <el-dialog
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            title="温馨提示"
            :visible.sync="dialogVisibleClose"
            :append-to-body="false"
            :show-close="false"
            width="30%"
            class="dialog-tip-title"
            >
            <div class="dialog-tip-text">推荐表填报系统已关闭！</div>
        </el-dialog>
    </div>
</template>

<script>
import { MU_UPATE_AUTH, MU_UPATE_SCHOOL } from "store/index";
import Bus from "components/bus.js";
import applyFileUpload from "components/uploads/uploadZip.vue";
export default {
    data() {
        return {
            files: [],
            urlAliyunOSS: "/api/design/osssign/getsign",
            headBg: require("assets/images/wlx-baic-bg-img.png"),
            form: {
                id:"",
                name: "",
                sex: "",
                bornDate: "",
                national: "",
                company: "",
                companyType: 1,
                position: "",
                workTitle: "",
                education: "",
                degree: "",
                schoolName: "",
                majorName: "",
                research: "",
                workMajor: "",
                address: "",
                postalCode: "",
                phone: "",
                mobilephone: "",
                idCard: "",
                email: "",
                recommendType: [],
                resume: "",
                achievements: "",
                opinion: "该候选人信息资料属实，同意推荐！",
                fileUrl: []
            },
            timer: "",
            showObject: {
                isShow: false,
            },
            isSubmit: false,
            rules: {
                name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
            },
            showTip: true,
            candidateId:'',
            dialogVisible:false,
            dialogVisibleClose:false,
            SIdcard:""
        };
    },
    components: {
        applyFileUpload,
    },
    created() {
        this.dialogVisible = true;
        // this.dialogVisibleClose = true;
    },
    methods: {
        fanhui() {
            this.$router.go(-1);
        },
        onAllFilesUploadlLOU(val) {
            this.form.fileUrl.push(val);
        },

        getExportSQBUrl(){
            if(this.candidateId){
                window.location.href = "/api/XOrg/Candidate/exportSQBUrl?id="+this.candidateId;
            }else{
                this.$message.warning('请先确定推荐表信息');
            }
        },
        //根据身份证号获取已有的信息
        getTableInfo(){
            this.$http.post("/api/XOrg/Candidate/getCandidateInfo",{
                idcard: this.SIdcard,
                type:1
            })
            .then(rst=>{
                if(rst.code>0){
                    this.dialogVisible=false;
                    this.form.id = rst.headFillInfo.Id;
                    this.candidateId = rst.headFillInfo.Id;
                    this.form.name = rst.headFillInfo.Name;
                    this.form.sex = rst.headFillInfo.Sex;
                    this.form.bornDate = rst.headFillInfo.BornDate;
                    this.form.national = rst.headFillInfo.National;
                    this.form.company = rst.headFillInfo.Company;
                    this.form.companyType = rst.headFillInfo.CompanyType;
                    this.form.position = rst.headFillInfo.Position;
                    this.form.workTitle = rst.headFillInfo.WorkTitle;
                    this.form.education = rst.headFillInfo.Education;
                    this.form.degree = rst.headFillInfo.Degree;
                    this.form.schoolName = rst.headFillInfo.SchoolName;
                    this.form.majorName = rst.headFillInfo.MajorName;
                    this.form.research = rst.headFillInfo.Research;
                    this.form.workMajor = rst.headFillInfo.WorkMajor;
                    this.form.address = rst.headFillInfo.Address;
                    this.form.postalCode = rst.headFillInfo.PostalCode;
                    this.form.phone = rst.headFillInfo.Phone;
                    this.form.mobilephone = rst.headFillInfo.Mobilephone;
                    this.form.idCard = rst.headFillInfo.IdCard ;
                    this.form.email = rst.headFillInfo.Email;
                    this.form.recommendType = Number(rst.headFillInfo.RecommendType);
                    this.form.resume = rst.headFillInfo.Resume;
                    this.form.achievements = rst.headFillInfo.Achievements;
                    this.form.opinion = rst.headFillInfo.Opinion;
                    this.form.fileUrl = JSON.parse(rst.headFillInfo.FileUrl);
                }else{
                    this.$message.warning(rst.msg);
                }
            })
        },
        saveInfo(formName) {
            // this.form.fileUrl;
            var reg = /^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/;
            var email = /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
            var idCard = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/;
            if (this.form.name == "") {
                this.$message({
                    message: "请输入姓名",
                    type: "warning",
                });
                return false;
            }
            if (this.form.sex === "") {
                this.$message({
                    message: "请选择性别",
                    type: "warning",
                });
                return false;
            }
            if (this.form.bornDate === "") {
                this.$message({
                    message: "请输入出生日期",
                    type: "warning",
                });
                return false;
            }
            if (this.form.national === "") {
                this.$message({
                    message: "请输入民族",
                    type: "warning",
                });
                return false;
            }
            if (this.form.company === "") {
                this.$message({
                    message: "请输入单位",
                    type: "warning",
                });
                return false;
            }
            if (this.form.companyType === "") {
                this.$message({
                    message: "请选择单位性质",
                    type: "warning",
                });
                return false;
            }
            if (this.form.workTitle === "") {
                this.$message({
                    message: "请输入职称",
                    type: "warning",
                });
                return false;
            }
            if (this.form.education === "") {
                this.$message({
                    message: "请输入学历",
                    type: "warning",
                });
                return false;
            }
            if (this.form.degree === "") {
                this.$message({
                    message: "请输入学位",
                    type: "warning",
                });
                return false;
            }
            if (this.form.majorName === "") {
                this.$message({
                    message: "请输入专业",
                    type: "warning",
                });
                return false;
            }
            if (this.form.research === "") {
                this.$message({
                    message: "请输入研究方向",
                    type: "warning",
                });
                return false;
            }
            if (this.form.workMajor === "") {
                this.$message({
                    message: "请输入目前从事专业",
                    type: "warning",
                });
                return false;
            }

            if (this.form.mobilephone == "") {
                this.$message({
                    message: "请输入号码",
                    type: "warning",
                });
                return false;
            } else if (!reg.test(this.form.mobilephone)) {
                this.$message({
                    message: "手机号格式不正确",
                    type: "warning",
                });
                return false;
            }
            if (this.form.email == "") {
                this.$message({
                    message: "请输入邮箱",
                    type: "warning",
                });
                return false;
            }else if(!email.test(this.form.email)){
                this.$message({
                    message: "邮箱格式不正确",
                    type: "warning",
                });
                return false;
            }
            if (this.form.recommendType == "") {
                this.$message({
                    message: "请勾选工作组",
                    type: "warning",
                });
                return false;
            }
            if (this.form.resume == "") {
                this.$message({
                    message: "请输入简历",
                    type: "warning",
                });
                return false;
            }
            if (this.form.achievements == "") {
                this.$message({
                    message: "请输入学术成果",
                    type: "warning",
                });
                return false;
            }
            if (this.form.opinion == "") {
                this.$message({
                    message: "请输入推荐单位意见",
                    type: "warning",
                });
                return false;
            }
            if (this.form.phone == "") {
                this.$message({
                    message: "请输入联系电话",
                    type: "warning",
                });
                return false;
            }
            if (this.form.schoolName == "") {
                this.$message({
                    message: "请输入毕业院校",
                    type: "warning",
                });
                return false;
            }
            if(this.form.idCard == "") {
                this.$message({
                    message: "请输入身份证号",
                    type: "warning",
                });
                return false;
            }else if (!idCard.test(this.form.idCard)) {
                this.$message({
                    message: "输入身份证号格式错误",
                    type: "warning",
                });
                return false;
            }
            if (this.form.position == "") {
                this.$message({
                    message: "请输入职务",
                    type: "warning",
                });
                return false;
            }
            if (this.form.address == "") {
                this.$message({
                    message: "请输入地址",
                    type: "warning",
                });
                return false;
            }
            // if (this.form.fileUrl.length == "") {
            //     this.$message({
            //         message: "请上传支撑材料",
            //         type: "warning",
            //     });
            //     return false;
            // }
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    // this.isSubmit = true;
                    this.$http
                        .post("/api/XOrg/Candidate/addoreditInfo", {
                            id: this.candidateId,
                            name: this.form.name,
                            sex: this.form.sex,
                            bornDate: this.form.bornDate,
                            national: this.form.national,
                            company: this.form.company,
                            companyType: this.form.companyType,
                            position: this.form.position,
                            workTitle: this.form.workTitle,
                            education: this.form.education,
                            degree: this.form.degree,
                            schoolName: this.form.schoolName,
                            majorName: this.form.majorName,
                            research: this.form.research,
                            workMajor: this.form.workMajor,
                            address: this.form.address,
                            postalCode: this.form.postalCode,
                            phone: this.form.phone,
                            mobilephone: this.form.mobilephone,
                            idCard: this.form.idCard,
                            email: this.form.email,
                            recommendType: this.form.recommendType,
                            resume: this.form.resume,
                            achievements: this.form.achievements,
                            opinion: this.form.opinion,
                            fileUrl: JSON.stringify(this.form.fileUrl),
                            type:1
                        })
                        .then((res) => {
                            if (res.code > 0) {
                                this.candidateId = res.id;
                                this.$message.success(res.msg);
                            } else {
                                this.isSubmit = false;
                                this.$message({
                                    message: res.msg,
                                    type: "warning",
                                });
                            }
                        });
                } else {
                    this.$message({
                        message: res.msg,
                        type: "warning",
                    });
                    return false;
                }
            });
        },
        submitTable(formName) {
            this.form.fileUrl;
            var reg = /^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/;
            var email = /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
            var idCard = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/;
            if (this.form.name == "") {
                this.$message({
                    message: "请输入姓名",
                    type: "warning",
                });
                return false;
            }
            if (this.form.sex === "") {
                this.$message({
                    message: "请选择性别",
                    type: "warning",
                });
                return false;
            }
            if (this.form.bornDate === "") {
                this.$message({
                    message: "请输入出生日期",
                    type: "warning",
                });
                return false;
            }
            if (this.form.national === "") {
                this.$message({
                    message: "请输入民族",
                    type: "warning",
                });
                return false;
            }
            if (this.form.company === "") {
                this.$message({
                    message: "请输入单位",
                    type: "warning",
                });
                return false;
            }
            if (this.form.companyType === "") {
                this.$message({
                    message: "请选择单位性质",
                    type: "warning",
                });
                return false;
            }
            if (this.form.workTitle === "") {
                this.$message({
                    message: "请输入职称",
                    type: "warning",
                });
                return false;
            }
            if (this.form.education === "") {
                this.$message({
                    message: "请输入学历",
                    type: "warning",
                });
                return false;
            }
            if (this.form.degree === "") {
                this.$message({
                    message: "请输入学位",
                    type: "warning",
                });
                return false;
            }
            if (this.form.majorName === "") {
                this.$message({
                    message: "请输入专业",
                    type: "warning",
                });
                return false;
            }
            if (this.form.research === "") {
                this.$message({
                    message: "请输入研究方向",
                    type: "warning",
                });
                return false;
            }
            if (this.form.workMajor === "") {
                this.$message({
                    message: "请输入目前从事专业",
                    type: "warning",
                });
                return false;
            }

            if (this.form.mobilephone == "") {
                this.$message({
                    message: "请输入号码",
                    type: "warning",
                });
                return false;
            } else if (!reg.test(this.form.mobilephone)) {
                this.$message({
                    message: "手机号格式不正确",
                    type: "warning",
                });
                return false;
            }
            if (this.form.email == "") {
                this.$message({
                    message: "请输入邮箱",
                    type: "warning",
                });
                return false;
            }else if(!email.test(this.form.email)){
                this.$message({
                    message: "邮箱格式不正确",
                    type: "warning",
                });
                return false;
            }
            if (this.form.recommendType == "") {
                this.$message({
                    message: "请勾选工作组",
                    type: "warning",
                });
                return false;
            }
            if (this.form.resume == "") {
                this.$message({
                    message: "请输入简历",
                    type: "warning",
                });
                return false;
            }
            if (this.form.achievements == "") {
                this.$message({
                    message: "请输入学术成果",
                    type: "warning",
                });
                return false;
            }
            if (this.form.opinion == "") {
                this.$message({
                    message: "请输入推荐单位意见",
                    type: "warning",
                });
                return false;
            }
            if (this.form.phone == "") {
                this.$message({
                    message: "请输入联系电话",
                    type: "warning",
                });
                return false;
            }
            if (this.form.schoolName == "") {
                this.$message({
                    message: "请输入毕业院校",
                    type: "warning",
                });
                return false;
            }
            if(this.form.idCard == "") {
                this.$message({
                    message: "请输入身份证号",
                    type: "warning",
                });
                return false;
            }else if (!idCard.test(this.form.idCard)) {
                this.$message({
                    message: "输入身份证号格式错误",
                    type: "warning",
                });
                return false;
            }
            if (this.form.position == "") {
                this.$message({
                    message: "请输入职务",
                    type: "warning",
                });
                return false;
            }
            if (this.form.address == "") {
                this.$message({
                    message: "请输入地址",
                    type: "warning",
                });
                return false;
            }
            // if (this.form.fileUrl.length == "") {
            //     this.$message({
            //         message: "请上传支撑材料",
            //         type: "warning",
            //     });
            //     return false;
            // }
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.isSubmit = true;
                    this.$http
                        .post("/api/XOrg/Candidate/addoreditInfo", {
                            id: this.candidateId,
                            name: this.form.name,
                            sex: this.form.sex,
                            bornDate: this.form.bornDate,
                            national: this.form.national,
                            company: this.form.company,
                            companyType: this.form.companyType,
                            position: this.form.position,
                            workTitle: this.form.workTitle,
                            education: this.form.education,
                            degree: this.form.degree,
                            schoolName: this.form.schoolName,
                            majorName: this.form.majorName,
                            research: this.form.research,
                            workMajor: this.form.workMajor,
                            address: this.form.address,
                            postalCode: this.form.postalCode,
                            phone: this.form.phone,
                            mobilephone: this.form.mobilephone,
                            idCard: this.form.idCard,
                            email: this.form.email,
                            recommendType: this.form.recommendType,
                            resume: this.form.resume,
                            achievements: this.form.achievements,
                            opinion: this.form.opinion,
                            fileUrl: JSON.stringify(this.form.fileUrl),
                            type:1
                        })
                        .then((res) => {
                            if (res.code > 0) {
                                this.$message.success(res.msg);
                                this.candidateId = res.id;
                            } else {
                                this.isSubmit = false;
                                this.$message({
                                    message: res.msg,
                                    type: "warning",
                                });
                            }
                        });
                } else {
                    this.$message({
                        message: res.msg,
                        type: "warning",
                    });
                    return false;
                }
            });
        },
    },
};
</script>

<style lang="scss">
.wlx-candidate-table-wrapper {
    height: 100%;
    overflow: auto;
    background: #f0f6ff;
    .basic-head-main {
        height: 706px;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center top;
        .basic-head-con {
            margin: 0 auto;
            width: 1000px;
        }
        .head-logo-con {
            padding: 26px 0 0 26px;
        }
        .logo-img-val {
            height: 40px;
        }
        .head-title-con {
            position: relative;
            padding-top: 40px;
        }
        .basic-book-img-con {
            margin-left: 10px;
        }
        .head-title-word {
            position: absolute;
            right: 0;
            top: 80px;
            z-index: 100;
            color: #fff;
        }
        .p-title-1 {
            font-size: 27px;
            font-weight: bold;
            text-align: center;
            width: 610px;
        }
        .p-title-2-1 {
            margin-top: 50px;
            text-align: right;
            font-size: 20px;
        }
    }
    .apply-table-content {
        margin: -325px auto 0;
        padding: 20px 0;
        padding-top: 50px;
        width: 1000px;
        background: #fff;
    }
    .apply-table-hearrd{
        text-align: center;
        font-size: 24px;
        line-height: 20px;
        margin-bottom: 10px;
    }
    .apply-file-upload {
        width: 380px;
        margin: 35px;
        .el-col-8 {
            margin-left: 9px;
        }
    }
    .p-down-applyTable-btn {
        text-align: right;
        color: #0365f5;
        padding: 0 22px 20px 0;
        cursor: pointer;
        font-size: 17px;
    }
    .apply-table-title {
        padding: 20px 0;
        text-align: center;
    }
    .submit-apply-btn {
        padding: 20px 0;
        text-align: center;
    }
    .label-job-con {
        padding: 0 20px;
    }
    table {
        margin: 0 auto;
        width: 960px;
        border-right: 1px solid #999;
        border-bottom: 1px solid #999;
        table-layout: fixed;
        word-break: break-all;
        background: #f0f0f0;
    }
    .u-label-title {
        font-weight: bold;
    }
    .demo-table {
        margin-top: 100px;
    }
    .expert-certify-ul {
        height: 100%;
    }
    .expert-certify-li {
        width: 25%;
    }
    .certify-li-cell {
        border-left: 1px solid #999;
        border-top: 1px solid #999;
    }
    .certify-li-cell-num {
        border-top: none;
    }
    .fistCertify {
        .certify-li-cell {
            border-left: none;
        }
    }
    .el-textarea__inner,
    .el-input__inner {
        border: none;
        font-size: 16px;
        color: #000;
    }
    .input-edu .el-input__inner {
        height: 82px;
        line-height: 82px;
    }
    .el-textarea__inner:focus {
        border: none;
    }
    .el-input__inner:focus {
        border: none;
    }
    .el-date-editor.el-input {
        width: 100%;
    }
    table td {
        border-left: 1px solid #999;
        border-top: 1px solid #999;
        text-align: center;
    }
    .label-opinion-title {
        padding: 10px;
        text-align: left;
    }
    .sp-mark-label {
        color: red;
    }
    .h4-major-title {
        padding: 10px 0;
    }
    td {
        height: 40px;
        // width: 76.9px;
        font-size: 16px;
    }
    .train-select-con {
        width: 100%;
    }
    .p-sign-up-tip {
        padding: 10px 0 0 20px;
    }
    .p-sign-up-tip-1 {
        margin-top: 40px;
    }
    .submit-btn {
        padding: 20px 0;
        text-align: center;
    }
    .wlx-is-fill-signUp-con {
        font-size: 16px;
        .p-name-pass-tip-con {
            margin-top: 10px;
            color: red;
        }
    }
    .train-sing-up-avatar-con {
        .el-upload-list--picture-card {
            .el-upload-list__item-thumbnail {
                width: auto;
            }
        }
    }
    .dialog-tip-text{
        text-align: center;
        font-size: 20px;
        height: 100px;
        line-height: 70px;
    }
    .dialog-tip-title{
        .el-dialog__header{
            .el-dialog__title{
                font-size: 24px;
            }
        }
    }
}
</style>
